import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "거버넌스",
  "description": "Vercel의 Turborepo는 웹을 위한 차세대 빌드 시스템입니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 2020년 Vercel의 팀에 의해 만들어졌습니다."
  }, {
    "heading": "",
    "content": "Turborepo의 연구 및 개발은 Vercel에서 풀타임으로 일하는 핵심 팀이 주도하고 있습니다. Turborepo는 웹 개발자를 위한 도구를 구축하기 위한 협력적인 오픈소스 프로젝트입니다."
  }, {
    "heading": "팀",
    "content": "Core Team: Vercel의 Turborepo 팀이 Turborepo의 방향을 관리하고 프로젝트를 주도합니다."
  }, {
    "heading": "팀",
    "content": "Documentation: Vercel의 DevRel 팀이 문서 및 학습 플랫폼을 관리합니다."
  }, {
    "heading": "roadmap-및-rfc-프로세스",
    "content": "대규모 아키텍처 결정 및 기능은 GitHub Discussions 내에서 Request for Comments (RFC)로 시작됩니다. 전체 Turborepo 커뮤니티가 프로세스에 참여하고 제안된 작업의 트레이드오프를 논의하도록 초대됩니다."
  }, {
    "heading": "roadmap-및-rfc-프로세스",
    "content": "이 프로세스는 커뮤니티 및 협력자와 함께 기능이 구축되도록 보장하는 데 필수적입니다. 버그 수정 및 문서 개선을 포함한 보다 사소한 변경 사항은 여전히 GitHub pull request를 통해 구현됩니다. 그러나 더 큰 이니셔티브의 경우 RFC 프로세스를 따르는 것이 필수적이라고 생각합니다."
  }, {
    "heading": "안정성-및-릴리스-단계",
    "content": "Experimental: Experimental 기능은 안정성을 위해 필요한 필수 기능이 부족합니다. 이 기능은 활발히 개발 중이며 Beta로 전환하기 위해 구축되고 있는 것으로 간주됩니다."
  }, {
    "heading": "안정성-및-릴리스-단계",
    "content": "Beta: Beta는 이 기능이 아직 안정적인 릴리스를 위한 품질 기준을 충족하지 못함을 의미합니다. 또한 일반적으로 이 기능이 다양한 환경에서 예상대로 작동하는지 검증하기 위해 Turborepo 개발자로부터 더 많은 정보나 피드백이 필요합니다."
  }, {
    "heading": "안정성-및-릴리스-단계",
    "content": "Stable: 기능이 안정성에 도달하면 프로덕션에서 사용할 준비가 된 것으로 간주됩니다. Stable로 표시된 API는 주요 릴리스가 아닌 한 하위 호환 가능한 방식으로만 변경됩니다."
  }, {
    "heading": "안정성-및-릴리스-단계",
    "content": "Deprecated: 기능이 제거되는 과정에 있습니다. Deprecated 기능에는 기존 사용자를 위한 다음 단계 및 기능이 제거될 것으로 예상되는 시기에 대한 정보가 포함된 문서가 포함됩니다."
  }, {
    "heading": "turborepo-지원",
    "content": "Turborepo 저장소에 대한 무료 지원을 찾는 개별 개발자는 GitHub Discussions 또는 Vercel Community의 #turborepo 태그에서 질문할 수 있습니다."
  }, {
    "heading": "turborepo-지원",
    "content": "Turborepo 저장소에 대한 유료 지원을 찾는 기업은 자세한 정보를 위해 Vercel의 Turborepo 팀에 문의할 수 있습니다."
  }, {
    "heading": "추가-리소스",
    "content": "로고 정책 및 브랜드 가이드라인"
  }, {
    "heading": "추가-리소스",
    "content": "보안 문제 보고"
  }, {
    "heading": "추가-리소스",
    "content": "행동 강령"
  }, {
    "heading": "추가-리소스",
    "content": "기여 가이드라인"
  }],
  "headings": [{
    "id": "팀",
    "content": "팀"
  }, {
    "id": "roadmap-및-rfc-프로세스",
    "content": "Roadmap 및 RFC 프로세스"
  }, {
    "id": "안정성-및-릴리스-단계",
    "content": "안정성 및 릴리스 단계"
  }, {
    "id": "turborepo-지원",
    "content": "Turborepo 지원"
  }, {
    "id": "추가-리소스",
    "content": "추가 리소스"
  }]
};
export const toc = [{
  depth: 2,
  url: "#팀",
  title: _jsx(_Fragment, {
    children: "팀"
  })
}, {
  depth: 2,
  url: "#roadmap-및-rfc-프로세스",
  title: _jsx(_Fragment, {
    children: "Roadmap 및 RFC 프로세스"
  })
}, {
  depth: 2,
  url: "#안정성-및-릴리스-단계",
  title: _jsx(_Fragment, {
    children: "안정성 및 릴리스 단계"
  })
}, {
  depth: 2,
  url: "#turborepo-지원",
  title: _jsx(_Fragment, {
    children: "Turborepo 지원"
  })
}, {
  depth: 2,
  url: "#추가-리소스",
  title: _jsx(_Fragment, {
    children: "추가 리소스"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 2020년 ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "의 팀에 의해 만들어졌습니다."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 연구 및 개발은 Vercel에서 풀타임으로 일하는 핵심 팀이 주도하고 있습니다. Turborepo는 웹 개발자를 위한 도구를 구축하기 위한 협력적인 오픈소스 프로젝트입니다."
    }), "\n", _jsx(_components.h2, {
      id: "팀",
      children: "팀"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Core Team"
      }), ": ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "의 Turborepo 팀이 Turborepo의 방향을 관리하고 프로젝트를 주도합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Documentation"
      }), ": ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "의 DevRel 팀이 문서 및 학습 플랫폼을 관리합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "roadmap-및-rfc-프로세스",
      children: "Roadmap 및 RFC 프로세스"
    }), "\n", _jsxs(_components.p, {
      children: ["대규모 아키텍처 결정 및 기능은 GitHub Discussions 내에서 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/categories/rfc",
        children: "Request for Comments (RFC)"
      }), "로 시작됩니다. 전체 Turborepo 커뮤니티가 프로세스에 참여하고 제안된 작업의 트레이드오프를 논의하도록 초대됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "이 프로세스는 커뮤니티 및 협력자와 함께 기능이 구축되도록 보장하는 데 필수적입니다. 버그 수정 및 문서 개선을 포함한 보다 사소한 변경 사항은 여전히 GitHub pull request를 통해 구현됩니다. 그러나 더 큰 이니셔티브의 경우 RFC 프로세스를 따르는 것이 필수적이라고 생각합니다."
    }), "\n", _jsx(_components.h2, {
      id: "안정성-및-릴리스-단계",
      children: "안정성 및 릴리스 단계"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Experimental"
        }), ": Experimental 기능은 안정성을 위해 필요한 필수 기능이 부족합니다. 이 기능은 활발히 개발 중이며 Beta로 전환하기 위해 구축되고 있는 것으로 간주됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Beta"
        }), ": Beta는 이 기능이 아직 안정적인 릴리스를 위한 품질 기준을 충족하지 못함을 의미합니다. 또한 일반적으로 이 기능이 다양한 환경에서 예상대로 작동하는지 검증하기 위해 Turborepo 개발자로부터 더 많은 정보나 피드백이 필요합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Stable"
        }), ": 기능이 안정성에 도달하면 프로덕션에서 사용할 준비가 된 것으로 간주됩니다. Stable로 표시된 API는 주요 릴리스가 아닌 한 하위 호환 가능한 방식으로만 변경됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Deprecated"
        }), ": 기능이 제거되는 과정에 있습니다. Deprecated 기능에는 기존 사용자를 위한 다음 단계 및 기능이 제거될 것으로 예상되는 시기에 대한 정보가 포함된 문서가 포함됩니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "turborepo-지원",
      children: "Turborepo 지원"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 저장소에 대한 무료 지원을 찾는 개별 개발자는 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions",
        children: "GitHub Discussions"
      }), " 또는 ", _jsxs(_components.a, {
        href: "https://community.vercel.com/tag/turborepo",
        children: ["Vercel Community의 ", _jsx(_components.code, {
          children: "#turborepo"
        }), " 태그"]
      }), "에서 질문할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 저장소에 대한 유료 지원을 찾는 기업은 자세한 정보를 위해 ", _jsx(_components.a, {
        href: "https://vercel.com/contact",
        children: "Vercel의 Turborepo 팀에 문의"
      }), "할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "추가-리소스",
      children: "추가 리소스"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://vercel.com/design/brands#turbo",
          children: "로고 정책 및 브랜드 가이드라인"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/SECURITY.md",
          children: "보안 문제 보고"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/CODE_OF_CONDUCT.md",
          children: "행동 강령"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/blob/main/CONTRIBUTING.md",
          children: "기여 가이드라인"
        })
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
